import React from 'react';

const AdvancedIvfLabPattern = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" width="1440" height="393" viewBox="0 0 1440 393" fill="none">
      <g clip-path="url(#clip0_418_4586)">
        <rect width="1440" height="393" fill="white" />
        <g opacity="0.53">
          <rect x="1063.64" y="30" width="28.8121" height="81" fill="#DDCAEB" />
          <rect x="1118" y="55.5503" width="28.8121" height="81" transform="rotate(90 1118 55.5503)" fill="#DDCAEB" />
        </g>
        <g opacity="0.53">
          <rect x="683.268" y="84" width="31.6577" height="89" fill="#DDCAEB" />
          <rect x="743" y="112.074" width="31.6577" height="89" transform="rotate(90 743 112.074)" fill="#DDCAEB" />
        </g>
        <g opacity="0.53">
          <rect x="388.047" y="61" width="22.7651" height="64" fill="#DDCAEB" />
          <rect x="431" y="81.188" width="22.7651" height="64" transform="rotate(90 431 81.188)" fill="#DDCAEB" />
        </g>
        <g opacity="0.53">
          <rect x="208.047" y="6" width="22.7651" height="64" fill="#DDCAEB" />
          <rect x="251" y="26.188" width="22.7651" height="64" transform="rotate(90 251 26.188)" fill="#DDCAEB" />
        </g>
        <g opacity="0.53">
          <rect x="1009.64" y="240" width="28.8121" height="81" fill="#DDCAEB" />
          <rect x="1064" y="265.55" width="28.8121" height="81" transform="rotate(90 1064 265.55)" fill="#DDCAEB" />
        </g>
        <g opacity="0.53">
          <rect x="1310.48" y="266" width="14.5839" height="41" fill="#DDCAEB" />
          <rect x="1338" y="278.933" width="14.5839" height="41" transform="rotate(90 1338 278.933)" fill="#DDCAEB" />
        </g>
        <g opacity="0.53">
          <rect x="870.061" y="166" width="21.698" height="61" fill="#DDCAEB" />
          <rect x="911" y="185.242" width="21.698" height="61" transform="rotate(90 911 185.242)" fill="#DDCAEB" />
        </g>
        <g opacity="0.4" filter="url(#filter0_d_418_4586)">
          <path d="M179.29 95.4C102.058 106.28 27.5831 62.3333 0 39V393H986.5C949.922 368.333 860.234 316.68 816.101 320.2C771.968 323.72 720.959 324.6 700.971 324.6C632.373 323.96 566.453 252.867 542.068 217.4C525.279 172.92 480.706 133 460.518 118.6C405.832 78.92 250.247 86.6 179.29 95.4Z" fill="#7F4A9B" />
        </g>
        <g opacity="0.61" filter="url(#filter1_d_418_4586)">
          <path d="M1295.5 155.5C1137.9 174.7 1076.83 59.8333 1066 0H1440V240C1418.4 180 1334.67 158.667 1295.5 155.5Z" fill="#7F4A9B" />
        </g>
      </g>
      <defs>
        <filter id="filter0_d_418_4586" x="-16" y="18" width="1028.5" height="396" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="5" />
          <feGaussianBlur stdDeviation="10.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_418_4586" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_418_4586" result="shape" />
        </filter>
        <filter id="filter1_d_418_4586" x="1046" y="-11" width="414" height="280" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="9" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_418_4586" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_418_4586" result="shape" />
        </filter>
        <clipPath id="clip0_418_4586">
          <rect width="1440" height="393" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AdvancedIvfLabPattern;